import { tv } from '@change/ds-utils';

export const RectangleStyles = tv({
	base: 'bg-icon-inverse-disabled h-[11px] w-[166px]',
	variants: {
		loading: {
			true: 'animate-pulse',
			false: '',
		},
		rounded: {
			true: 'rounded-[28px]',
			false: '',
		},
	},
});
